import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { BackButton, PlusButton } from "../buttons";
import { routes } from "routes";
import "./CollectionsHeader.scss";

export const CollectionsHeader = (props: {
  editable: boolean;
  onCreate: () => void;
}): JSX.Element => {
  const userName = useSelector((state: IAppState) => state.user.currentUser.username);

  const onClick = () => {
    if (props.onCreate) {
      props.onCreate();
    } else {
      console.warn("The onClick property not set for CollectionsHeader.");
    }
  };

  return (
    <div className="collectionsHeader">
      <BackButton
        link={routes.user(userName)}
      />

      {props.editable ? (
        <h2 className="header">Saved</h2>
      ) : (
        <h2 className="header">Collections by {userName}</h2>
      )}

      {props.editable && <PlusButton
        onClick={onClick}
        hint="Create a new collection"
      />}
    </div>
  );
};
